<mat-card>
    <mat-card-content>
      <button id="btn-cloud-providers" [routerLink]="['cloudproviders']" mat-raised-button color="primary">Cloud Providers</button>
    </mat-card-content>
  </mat-card>
  <br>
  <router-outlet>
  
  </router-outlet>
